import { closeUnsavedChangesModal, useTemplate } from '@/stores/template';
import { Button, cn, Modal, Spinner } from '@skand/ui';

export interface UnsavedChangesConfirmationModalState {
  isOpen: boolean;
  isLoading: boolean;
  saveChangesAndProceed: () => void;
  discardChanges: () => void;
}

interface UnsavedChangesConfirmationModalProps {
  className?: string;
  buttonContainerClassName?: string;
}

export const UnsavedChangesConfirmationModal = ({
  className,
  buttonContainerClassName,
}: UnsavedChangesConfirmationModalProps) => {
  const { isOpen, isLoading, saveChangesAndProceed, discardChanges } = useTemplate(
    state => state.unsavedChangesConfirmationModalState,
  );

  return isOpen ? (
    <Modal className={className}>
      <div className="z-20 mt-1 flex flex-col gap-2">
        <p className="color-neutral-800 typo-text-m">Unsaved Changes</p>
        <p className="max-h-128px overflow-auto color-neutral-800 typo-text-s">
          You have unsaved changes. Are you sure you want to leave without saving?
        </p>
      </div>
      <div className={cn('w-full flex gap-2', buttonContainerClassName)}>
        <Button
          className="w-full cursor-pointer"
          disabled={isLoading}
          onClick={() => closeUnsavedChangesModal()}
          size="s"
        >
          <div className="flex items-center justify-center gap-2">
            {isLoading && <Spinner className="animate-spin" color="neutral" />}
            Cancel
          </div>
        </Button>
        <Button
          className="w-full cursor-pointer"
          disabled={isLoading}
          onClick={() => discardChanges()}
          size="s"
        >
          <div className="flex items-center justify-center gap-2">
            {isLoading && <Spinner className="animate-spin" color="neutral" />}
            Don&apos;t save
          </div>
        </Button>
        <Button
          className="w-full cursor-pointer"
          disabled={isLoading}
          filled
          onClick={() => saveChangesAndProceed()}
          primary
          size="s"
        >
          <div className="flex items-center justify-center gap-2">
            {isLoading && <Spinner className="animate-spin" color="neutral" />}
            Save changes
          </div>
        </Button>
      </div>
    </Modal>
  ) : null;
};
